import {Injectable, NgModule} from '@angular/core';
import {
  Translation,
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  translocoConfig,
  TranslocoLoader,
  TranslocoModule,
  TRANSLOCO_TRANSPILER,
  DefaultTranspiler,
  TRANSLOCO_MISSING_HANDLER,
  DefaultMissingHandler,
  TRANSLOCO_INTERCEPTOR,
  TRANSLOCO_FALLBACK_STRATEGY,
  DefaultInterceptor
} from '@jsverse/transloco';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';


@Injectable({providedIn: 'root'})
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {
  }

  getTranslation(lang: string): Observable<Translation> {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json?cb=${new Date().getTime()}`);
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: ['en'],
        defaultLang: 'en',
        prodMode: environment.production,
      })
    },
    {provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader},
    {provide: TRANSLOCO_TRANSPILER, useClass: DefaultTranspiler},
    {provide: TRANSLOCO_MISSING_HANDLER, useClass: DefaultMissingHandler},
    {provide: TRANSLOCO_INTERCEPTOR, useClass: DefaultInterceptor},
    {provide: TRANSLOCO_FALLBACK_STRATEGY, useValue: null}
  ]
})
export class TranslocoRootModule {
}